export const PageBreak = () => {
  return <div style={{ pageBreakAfter: 'always' }} />;
};
